module.exports = __webpack_public_path__ + "static/Q7Answer2_Snow_FabianMardi-8a9f3685ed412cbcc9c25301cf585617.jpg";